import type { IconData } from '@stacksjs/iconify-core'

export const arrowDiagonal2: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M23.593 7.175c1.244-1.572.338-3.652-1.658-3.847c-4.902-.48-10.555-.358-15.067-.106a3.863 3.863 0 0 0-3.646 3.646c-.254 4.535-.376 10.222.113 15.14c.196 1.974 2.233 2.873 3.79 1.644c1.22-.962 2.805-2.3 4.785-4.135c1.912 2.182 4.55 5.043 8.04 8.533c3.494 3.494 6.357 6.133 8.539 8.046c-1.794 1.942-3.118 3.511-4.082 4.729c-1.244 1.572-.338 3.652 1.658 3.847c4.902.48 10.555.358 15.067.106a3.863 3.863 0 0 0 3.646-3.646c.254-4.535.376-10.222-.113-15.14c-.196-1.974-2.233-2.873-3.79-1.644c-1.225.966-2.819 2.312-4.81 4.158a174 174 0 0 0-8.016-8.555a174 174 0 0 0-8.561-8.021c1.805-1.954 3.137-3.532 4.105-4.755\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowDiagonal2
